import React from 'react';

interface BlinqxLogoProps {
  height?: number | string;
  width?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

const BlinqxLogo: React.FC<BlinqxLogoProps> = ({
  height = 32,
  width = 'auto',
  className,
  style,
  ...props
}) => {
  return (
    <svg
      width='181'
      height='32'
      viewBox='0 0 181 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      style={{ height, width, ...style }}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M110.529 7.70898C115.244 7.70901 119.178 11.5466 119.178 16.1184C119.177 20.6901 115.244 24.5512 110.529 24.5512C105.861 24.5512 101.881 20.6901 101.881 16.1184C101.881 11.5466 105.861 7.70898 110.529 7.70898ZM110.529 10.8832C107.804 10.8832 105.482 13.2995 105.482 16.1184C105.482 18.9609 107.804 21.377 110.529 21.377C113.278 21.3769 115.6 18.9609 115.6 16.1184C115.6 13.2995 113.278 10.8832 110.529 10.8832Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M55.8968 24.2671H51.9634L50.921 21.7087H43.6706L42.6278 24.2671H38.7182L45.3528 7.99336H49.2624L55.8968 24.2671ZM44.879 18.7478H49.7126L47.2958 12.802L44.879 18.7478Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M65.137 7.99336C68.6675 7.99336 71.274 10.2674 71.2741 13.4889C71.2741 16.7105 68.6675 18.9848 65.137 18.9848H61.2987V24.2671H57.8155V7.99336H65.137ZM61.2987 15.7868H64.758C66.4877 15.7868 67.6723 14.8865 67.6723 13.4889C67.6723 12.0914 66.4877 11.1913 64.758 11.1913H61.2987V15.7868Z'
        fill='white'
      />
      <path d='M77.0118 24.2671H73.5049V7.99336H77.0118V24.2671Z' fill='white' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M94.2 7.99336C97.7304 7.99341 100.337 10.2674 100.337 13.4889C100.337 16.7105 97.7304 18.9847 94.2 18.9848H90.3615V24.2671H86.8783V7.99336H94.2ZM90.3615 15.7868H93.8207C95.5504 15.7868 96.7353 14.8865 96.7353 13.4889C96.7353 12.0914 95.5504 11.1913 93.8207 11.1913H90.3615V15.7868Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M129.071 7.99336C132.601 7.99336 135.207 10.2674 135.207 13.4889C135.207 15.9051 133.738 17.8002 131.511 18.5819L135.516 24.2671H131.535L127.815 18.9848H125.232V24.2671H121.749V7.99336H129.071ZM125.232 15.7868H128.692C130.421 15.7868 131.606 14.8865 131.606 13.4889C131.606 12.0914 130.421 11.1913 128.692 11.1913H125.232V15.7868Z'
        fill='white'
      />
      <path
        d='M150.603 11.1439H145.532V24.2671H142.025V11.1439H136.954V7.99336H150.603V11.1439Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M167.589 24.2671H163.656L162.614 21.7087H155.363L154.321 24.2671H150.411L157.046 7.99336H160.955L167.589 24.2671ZM156.571 18.7478H161.405L158.988 12.802L156.571 18.7478Z'
        fill='white'
      />
      <path d='M172.896 21.1165H181V24.2671H169.39V7.99336H172.896V21.1165Z' fill='white' />
      <path
        d='M15.634 15.7254L24.7469 25.7194L27.7328 24V8L13.8664 0L0 8V24L13.8664 32L21.57 27.5463L10.6894 15.6896L15.634 15.7254Z'
        fill='#FFCD00'
      />
    </svg>
  );
};

export default BlinqxLogo;
